<template>

  <div class="flex flex-col lg:flex-row h-full w-full bg-n-background overflow-hidden">

    <!-- Main Left Area: Content Feed -->

    <div class="flex-1 flex flex-col min-w-0 border-r border-n-weak overflow-hidden">

                  <!-- Top Navigation & Global Header (Design System 2.0 Responsive Floating Card) -->
      <div class="px-6 pt-4 pb-2 bg-n-background shrink-0">
        <div class="p-3.5 sm:p-4 rounded-2xl bg-white dark:bg-[#1a1b20] border border-slate-200 dark:border-[#26282d] shadow-xs space-y-3">
          <!-- Row 1: Abas Superiores em Segmented Pill & Botões de Ação -->
          <div class="flex flex-wrap items-center justify-between gap-3 pb-3 border-b border-slate-100 dark:border-[#26282d]">
            <!-- Abas Superiores (Segmented Control) -->
            <div class="flex items-center gap-1.5 p-1 bg-slate-100 dark:bg-[#15161a] rounded-xl border border-slate-200 dark:border-[#26282d] overflow-x-auto max-w-full">
              <!-- ABA NÃO LIDAS -->
              <button
                @click="selectTab('nao_lidas')"
                :class="[
                  'px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all whitespace-nowrap cursor-pointer flex items-center gap-1.5',
                  activeTab === 'nao_lidas'
                    ? 'bg-white dark:bg-[#2781F6] text-[#2781F6] dark:text-white shadow-xs'
                    : 'text-slate-500 hover:text-slate-900 dark:hover:text-slate-200'
                ]"
              >
                <span>Não Lidas</span>
                <span
                  v-if="meta.unread_count > 0"
                  :class="[
                    'text-[10px] px-1.5 py-0.2 rounded-full font-black',
                    activeTab === 'nao_lidas'
                      ? 'bg-blue-50 dark:bg-white/20 text-[#2781F6] dark:text-white'
                      : 'bg-amber-100 text-amber-900 border border-amber-300 dark:bg-amber-950/60 dark:text-amber-300'
                  ]"
                >
                  {{ meta.unread_count }}
                </span>
              </button>

              <!-- ABA TODAS -->
              <button
                @click="selectTab('todas')"
                :class="[
                  'px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all whitespace-nowrap cursor-pointer flex items-center gap-1.5',
                  activeTab === 'todas'
                    ? 'bg-white dark:bg-[#2781F6] text-[#2781F6] dark:text-white shadow-xs'
                    : 'text-slate-500 hover:text-slate-900 dark:hover:text-slate-200'
                ]"
              >
                <span>Todas</span>
                <span
                  v-if="meta.total_count > 0"
                  :class="[
                    'text-[10px] px-1.5 py-0.2 rounded-full font-semibold',
                    activeTab === 'todas'
                      ? 'bg-blue-50 dark:bg-white/20 text-[#2781F6] dark:text-white'
                      : 'bg-slate-200 dark:bg-[#26282d] text-slate-600 dark:text-slate-400'
                  ]"
                >
                  {{ meta.total_count }}
                </span>
              </button>

              <!-- ABA FAVORITAS -->
              <button
                @click="selectTab('favoritas')"
                :class="[
                  'px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all whitespace-nowrap cursor-pointer flex items-center gap-1.5',
                  activeTab === 'favoritas'
                    ? 'bg-white dark:bg-[#2781F6] text-[#2781F6] dark:text-white shadow-xs'
                    : 'text-slate-500 hover:text-slate-900 dark:hover:text-slate-200'
                ]"
              >
                <span class="i-lucide-star size-3.5 text-amber-400 fill-amber-400" />
                <span>Favoritas</span>
                <span
                  v-if="meta.favorites_count > 0"
                  :class="[
                    'text-[10px] px-1.5 py-0.2 rounded-full font-semibold',
                    activeTab === 'favoritas'
                      ? 'bg-blue-50 dark:bg-white/20 text-[#2781F6] dark:text-white'
                      : 'bg-slate-200 dark:bg-[#26282d] text-slate-600 dark:text-slate-400'
                  ]"
                >
                  {{ meta.favorites_count }}
                </span>
              </button>
            </div>

            <!-- Botões de Ação Topo -->
            <div class="flex items-center gap-2">
              <button
                @click="openLawyersModal"
                type="button"
                class="px-3 py-1.5 rounded-xl bg-slate-100 dark:bg-[#15161a] hover:bg-slate-200 dark:hover:bg-[#26282d] text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-[#26282d] text-xs font-bold flex items-center gap-1.5 transition-all cursor-pointer shadow-2xs"
                title="Gerenciar advogados monitorados desta conta"
              >
                <span class="i-lucide-users size-3.5 text-[#2781F6]" />
                <span>Advogados</span>
              </button>

              <button
                @click="showMobileFilters = true"
                class="lg:hidden flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold rounded-xl bg-[#2781F6] text-white hover:bg-[#1c6edb] transition-all shadow-2xs cursor-pointer"
              >
                <span class="i-lucide-filter size-3.5" />
                <span>Filtros</span>
                <span v-if="hasActiveFilters || selectedDate || filtroDocumentos !== 'all'" class="size-2 rounded-full bg-amber-300" />
              </button>

              <button
                @click="showWebhookModal = true"
                class="px-3 py-1.5 rounded-xl bg-sky-50 dark:bg-sky-500/15 hover:bg-sky-100 dark:hover:bg-sky-500/25 text-sky-600 dark:text-sky-400 border border-sky-200 dark:border-sky-500/30 text-xs font-bold flex items-center gap-1.5 transition-all cursor-pointer shadow-2xs"
              >
                <span class="i-lucide-webhook size-3.5" />
                <span>Integração N8N / API</span>
              </button>
            </div>
          </div>

          <!-- Row 2: Busca, Filtros, Seleção em Massa e Contagem -->
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex flex-wrap items-center gap-3 flex-1 min-w-[280px]">
              <!-- Seleção em Massa -->
              <div class="flex items-center gap-2 shrink-0">
                <input
                  type="checkbox"
                  :checked="selectedIds.length > 0 && selectedIds.length === intimacoes.length"
                  :indeterminate="selectedIds.length > 0 && selectedIds.length < intimacoes.length"
                  @change="toggleSelectAll"
                  class="size-4 rounded border-slate-300 text-[#2781F6] focus:ring-[#2781F6] cursor-pointer"
                />
                <span class="text-xs font-medium text-slate-500 dark:text-slate-400 whitespace-nowrap">
                  {{ selectedIds.length === 0 ? 'Selecionar' : `${selectedIds.length} sel.` }}
                </span>
              </div>

              <!-- Ações em Massa (quando selecionadas) -->
              <div v-if="selectedIds.length > 0" class="flex items-center gap-1.5 animate-fadeIn shrink-0">
                <button
                  @click="handleBulkAction({ is_read: true })"
                  class="px-2.5 py-1 text-xs font-bold rounded-lg bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/30 flex items-center gap-1 cursor-pointer transition-all"
                  title="Marcar selecionadas como lidas"
                >
                  <span class="i-lucide-mail-open size-3.5 text-emerald-500" />
                  Lidas
                </button>
                <button
                  @click="handleBulkAction({ is_read: false })"
                  class="px-2.5 py-1 text-xs font-bold rounded-lg bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-500/30 flex items-center gap-1 cursor-pointer transition-all"
                  title="Marcar selecionadas como não lidas"
                >
                  <span class="i-lucide-mail size-3.5 text-amber-500" />
                  Não lidas
                </button>
                <button
                  @click="handleBulkAction({ is_favorite: true })"
                  class="px-2.5 py-1 text-xs font-bold rounded-lg bg-blue-50 dark:bg-blue-950/40 text-brand-600 dark:text-brand-400 border border-brand-200 dark:border-brand-500/30 flex items-center gap-1 cursor-pointer transition-all"
                  title="Favoritar selecionadas"
                >
                  <span class="i-lucide-star size-3.5 text-[#2781F6] fill-[#2781F6]" />
                  Favoritar
                </button>
              </div>

              <!-- Campo de Busca com Lupa e Botão Limpar -->
              <div class="relative flex-1 min-w-[200px]">
                <span class="i-lucide-search absolute left-3 top-1/2 -translate-y-1/2 size-3.5 text-slate-400 pointer-events-none" />
                <input
                  v-model="searchQuery"
                  @input="onSearchInput"
                  type="text"
                  placeholder="Buscar processo, tribunal ou texto..."
                  class="w-full bg-slate-50 dark:bg-[#15161a] border border-slate-200 dark:border-[#26282d] rounded-xl pl-8.5 pr-8 py-1.5 text-xs text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:outline-none focus:border-[#2781F6] transition-colors"
                />
                <button
                  v-if="searchQuery"
                  @click="searchQuery = ''; onSearchInput()"
                  class="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 cursor-pointer"
                >
                  <span class="i-lucide-x size-3.5" />
                </button>
              </div>

              <!-- Filtro Cascata de Advogados -->
              <div class="shrink-0 min-w-[150px]">
                <select
                  v-model="filtroAdvogado"
                  @change="fetchIntimacoes"
                  class="w-full h-8.5 px-3 text-xs font-medium bg-slate-50 dark:bg-[#15161a] border border-slate-200 dark:border-[#26282d] rounded-xl text-slate-700 dark:text-slate-300 focus:outline-none focus:border-[#2781F6] cursor-pointer shadow-2xs transition-colors"
                  title="Filtrar por Advogado Participante"
                >
                  <option value="all">⚖️ Todos os Advogados</option>
                  <option value="vinicius_fiscarelli">⭐ VINICIUS DE MARCO FISCARELLI (Principal)</option>
                  <option value="only_vinicius">🎯 Apenas Vinícius Fiscarelli (Exclusivo)</option>
                  <option
                    v-for="adv in registeredLawyersList"
                    :key="adv.key || adv.name"
                    :value="adv.key || adv.name"
                  >
                    👤 {{ adv.name }}
                  </option>
                  <option value="outros">📁 Gerais / Sem Advogados Listados</option>
                </select>
              </div>

              <!-- Filtro de Pedido de Documentação -->
              <div class="shrink-0 min-w-[150px]">
                <select
                  v-model="filtroDocumentos"
                  @change="fetchIntimacoes"
                  class="w-full h-8.5 px-3 text-xs font-medium bg-slate-50 dark:bg-[#15161a] border rounded-xl focus:outline-none focus:border-[#2781F6] cursor-pointer shadow-2xs transition-colors"
                  :class="filtroDocumentos !== 'all'
                    ? 'border-[#2781F6]/50 text-[#2781F6] font-bold bg-[#2781F6]/10'
                    : 'border-slate-200 dark:border-[#26282d] text-slate-700 dark:text-slate-300'"
                  title="Filtrar por Pedido de Documentação"
                >
                  <option value="all">Documentos: Todos</option>
                  <option value="com_documentos">📥 Com Pedido de Documentos</option>
                  <option value="sem_documentos">📤 Sem Pedido de Documentos</option>
                </select>
              </div>
            </div>

            <!-- Contagem Total -->
            <span class="text-[11px] text-slate-400 whitespace-nowrap font-medium shrink-0">
              {{ meta.total_count || intimacoes.length }} publicações
            </span>
          </div>
        </div>
      </div>


      <!-- Feed List -->

      <div class="flex-1 overflow-y-auto p-6 space-y-4 no-scrollbar">

        <div v-if="uiFlags.isFetching" class="flex flex-col items-center justify-center p-12 text-n-slate-10 gap-3">

          <span class="i-lucide-loader-2 size-6 animate-spin text-[#2781F6]" />

          <span class="text-xs font-medium">Carregando intimações...</span>

        </div>



        <div v-else-if="intimacoes.length === 0" class="flex flex-col items-center justify-center p-16 text-center border border-dashed border-n-weak rounded-2xl bg-n-solid-1/50">

          <div class="p-4 rounded-full bg-n-alpha-2 text-n-slate-10 mb-3">

            <span class="i-lucide-scale size-8" />

          </div>

          <h3 class="text-sm font-semibold text-n-slate-12 mb-1">Nenhuma intimação encontrada</h3>

          <p class="text-xs text-n-slate-10 max-w-sm mb-4">

            {{ activeTab === 'favoritas' ? 'Você ainda não marcou nenhuma intimação como favorita.' : 'Nenhuma publicação cadastrada ou correspondente aos filtros para esta data.' }}

          </p>

          <button

            v-if="hasActiveFilters"

            @click="clearFilters"

            class="px-3 py-1.5 text-xs font-medium rounded-lg bg-[#2781F6] text-white hover:bg-[#2781F6]/90 transition-all cursor-pointer"

          >

            Limpar Filtros

          </button>

        </div>



        <!-- Publication Card Item with #FAFADC for Unread -->

        <div

          v-for="(item, index) in intimacoes"

          :key="item.id"

          :class="[

            'border rounded-xl p-4 transition-all duration-150',

            item.is_read

              ? 'bg-n-solid-1 border-n-weak border-l-4 border-l-transparent hover:border-n-slate-8 text-n-slate-12'

              : 'border-[#d6d68b] border-l-4 border-l-[#2781F6] shadow-sm unread-intimacao-card'

          ]"

        >

          <div class="flex items-start gap-3">

            <!-- Checkbox & Expand Toggle -->

            <div class="flex flex-col items-center gap-2 pt-0.5">

              <input

                type="checkbox"

                :checked="selectedIds.includes(item.id)"

                @change="toggleSelect(item.id)"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6] cursor-pointer"

              />

              <button

                @click="toggleExpand(item.id)"

                class="p-1 rounded-md text-n-slate-10 hover:text-n-slate-12 hover:bg-n-alpha-2 transition-all cursor-pointer"

                :title="expandedIds.includes(item.id) ? 'Recolher' : 'Expandir'"

              >

                <span :class="expandedIds.includes(item.id) ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'" class="size-4" />

              </button>

            </div>



            <!-- Card Content Body -->

            <div class="flex-1 min-w-0">

              <!-- Top Row Info -->

              <div class="flex flex-wrap items-center gap-2.5 mb-2">

                <span class="text-xs font-bold" :class="item.is_read ? 'text-slate-500 dark:text-slate-400' : 'text-slate-900 dark:text-slate-100 font-bold'">

                  #{{ item.sequential_number || index + 1 }}

                </span>



                <!-- Unread Pill Badge -->
                <span
                  v-if="!item.is_read"
                  class="px-2 py-0.5 text-[10px] font-black rounded-md bg-[#1F93FF] text-white uppercase tracking-wider shadow-xs"
                >
                  NÃO LIDA
                </span>

                <span class="px-2 py-0.5 text-xs font-bold rounded-md bg-[#1F93FF]/15 text-[#1F93FF] uppercase tracking-wider">
                  {{ item.jornal || 'DJEN' }}
                </span>

                <!-- Badge Pedido de Documentos -->
                <span
                  v-if="hasDocumentRequest(item)"
                  class="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold rounded-md bg-indigo-50 dark:bg-indigo-950/70 border border-indigo-200 dark:border-indigo-800 text-indigo-700 dark:text-indigo-300"
                  title="Esta intimação exige apresentação/juntada de documentos"
                >
                  <span class="i-lucide-file-text size-3 text-indigo-600 dark:text-indigo-400 shrink-0" />
                  Pedido de Documentos
                </span>



                <div v-if="item.process_number" class="flex items-center gap-1.5 px-2 py-0.5 rounded-md bg-black/5 dark:bg-black/10 text-xs font-semibold" :class="item.is_read ? 'text-n-slate-12' : 'text-slate-900 dark:text-slate-900'">

                  <span>Proc: {{ item.process_number }}</span>

                  <button

                    @click.stop="copyToClipboard(item.process_number)"

                    class="text-n-slate-10 hover:text-[#2781F6] cursor-pointer"

                    title="Copiar número do processo"

                  >

                    <span class="i-lucide-copy size-3.5" />

                  </button>

                </div>



                <span class="text-xs ml-auto" :class="item.is_read ? 'text-n-slate-11' : 'text-slate-700 dark:text-slate-800'">

                  Disponibilização: {{ formatDate(item.date_availability) }}

                </span>



                <!-- Action Icons -->

                <div class="flex items-center gap-1 ml-2">

                  <button

                    @click="handleToggleFavorite(item.id)"

                    class="p-1.5 rounded-md hover:bg-black/5 transition-all cursor-pointer"

                    :title="item.is_favorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'"

                  >

                    <span

                      :class="[

                        'size-4',

                        item.is_favorite

                          ? 'i-lucide-star text-[#2781F6] fill-[#2781F6]'

                          : 'i-lucide-star text-n-slate-10 hover:text-[#2781F6]'

                      ]"

                    />

                  </button>



                  <button

                    @click="handleToggleRead(item.id)"

                    class="p-1.5 rounded-md hover:bg-black/5 text-n-slate-10 hover:text-n-slate-12 transition-all cursor-pointer"

                    :title="item.is_read ? 'Marcar como não lida' : 'Marcar como lida'"

                  >

                    <span :class="item.is_read ? 'i-lucide-mail-open text-emerald-500' : 'i-lucide-mail text-amber-600'" class="size-4" />

                  </button>

                </div>

              </div>



              <!-- AI Structured Box (Vermelho=Extinção, Verde=Homologação/Pagamento, Azul=Ação Necessária, Slate=Mera Movimentação) -->
              <div
                v-if="item.dados && (item.dados.titulo || item.dados.resumo_decisao || item.dados.proximo_passo || item.dados.prazo_concedido || item.dados.tipo_comunicacao)"
                class="mb-3 rounded-xl border transition-all overflow-hidden"
                :class="isExtinctionOrDismissal(item)
                  ? 'bg-[#FCDADD] dark:bg-[#331919] border-rose-300 dark:border-[#592424] shadow-xs'
                  : isHomologacao(item)
                    ? 'bg-[#dcfce7] dark:bg-[#0f2318] border-emerald-300 dark:border-[#1a4731] shadow-xs'
                    : isActionRequired(item)
                      ? 'bg-[#eef6ff] dark:bg-[#1D232F] border-[#bcdcfe] dark:border-[#2b3547] shadow-xs'
                      : 'bg-slate-100/90 dark:bg-slate-900/80 border-slate-200 dark:border-slate-800'"
              >
                <!-- 1. CASO ESPECIAL DE ATENÇÃO: Extinção do Processo / Indeferimento da Inicial (Fundo Vermelho #FCDADD / Dark #331919) -->
                <div v-if="isExtinctionOrDismissal(item)" class="p-3.5 space-y-3 text-xs">
                  <!-- Header: Badges & Título -->
                  <div class="space-y-1.5">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-black bg-rose-200 dark:bg-rose-900/90 border border-rose-400 dark:border-rose-700 text-rose-950 dark:text-rose-100 uppercase tracking-wider shadow-2xs">
                        <span class="i-lucide-alert-octagon size-3.5 text-rose-700 dark:text-rose-300 shrink-0" />
                        [EXTINÇÃO / INDEFERIMENTO DA INICIAL]
                      </span>

                      <span
                        v-if="item.dados.tipo_comunicacao"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-white/70 dark:bg-black/40 text-rose-950 dark:text-rose-200 border border-rose-300/80 dark:border-rose-900/80"
                      >
                        📋 {{ item.dados.tipo_comunicacao }}
                      </span>

                      <span
                        v-if="item.dados.data_limite_estimada"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-white/80 dark:bg-black/50 border border-rose-300 dark:border-rose-800 text-rose-950 dark:text-rose-200 ml-auto"
                      >
                        <span class="i-lucide-calendar-clock size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                        Data Limite: {{ item.dados.data_limite_estimada }}
                      </span>
                    </div>

                    <!-- Título gerado pela IA -->
                    <h4 v-if="item.dados.titulo" class="text-xs md:text-sm font-black text-rose-950 dark:text-rose-100 tracking-tight leading-snug pt-0.5">
                      {{ item.dados.titulo }}
                    </h4>
                  </div>

                  <!-- Resumo da Decisão Judicial -->
                  <div v-if="item.dados.resumo_decisao || getResumoDecisao(item)" class="space-y-1">
                    <div class="flex items-center gap-1.5 font-black text-rose-900 dark:text-rose-300 text-[11px] uppercase tracking-wider">
                      <span class="i-lucide-scale size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                      Resumo da Decisão:
                    </div>
                    <div class="leading-relaxed font-semibold text-rose-950 dark:text-rose-100 pl-5 text-xs">
                      {{ cleanDecisionText(item.dados.resumo_decisao || getResumoDecisao(item)) }}
                    </div>
                  </div>

                  <!-- Box do Próximo Passo do Advogado (se houver) -->
                  <div
                    v-if="item.dados.proximo_passo"
                    class="p-3 rounded-lg bg-white/90 dark:bg-[#201010] border border-rose-300 dark:border-[#592424] shadow-2xs space-y-1"
                  >
                    <div class="flex items-center gap-1.5 text-[11px] font-black text-rose-900 dark:text-rose-300 uppercase tracking-wider">
                      <span class="i-lucide-arrow-right-circle size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                      Próximo Passo / Providência do Advogado:
                    </div>
                    <div class="text-xs text-rose-950 dark:text-rose-50 font-black leading-relaxed">
                      {{ item.dados.proximo_passo }}
                    </div>
                  </div>

                  <!-- Metadados: Cliente, Vara e Dias -->
                  <div class="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs pt-1 border-t border-rose-300/60 dark:border-rose-900/60">
                    <div v-if="item.dados.parte_autora" class="flex items-center gap-1.5 text-rose-950 dark:text-rose-200">
                      <span class="i-lucide-user size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                      <span>Cliente: <strong class="font-black underline text-rose-950 dark:text-rose-100">{{ item.dados.parte_autora }}</strong></span>
                    </div>
                    <div v-if="item.dados.orgao_vara" class="flex items-center gap-1.5 text-rose-900 dark:text-rose-300 truncate max-w-sm">
                      <span class="i-lucide-landmark size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                      <span>{{ item.dados.orgao_vara }}</span>
                    </div>
                    <div v-if="item.dados.prazo_concedido && item.dados.prazo_concedido !== '0'" class="flex items-center gap-1 font-black text-rose-950 dark:text-rose-200 ml-auto">
                      <span class="i-lucide-hourglass size-3.5 text-rose-700 dark:text-rose-400 shrink-0" />
                      <span>{{ item.dados.prazo_concedido }} dias concedidos</span>
                    </div>
                  </div>
                </div>

                <!-- 2. Caso: Ação Necessária (Com Fundo Azul Suave e Badge Vermelho Vibrante) -->
                <div v-else-if="isActionRequired(item)" class="p-3.5 space-y-3 text-xs">
                  <!-- Header: Badges & Título da IA -->
                  <div class="space-y-1.5">
                    <div class="flex items-center gap-2 flex-wrap">
                      <!-- Badge Ação Necessária com Tom Vermelho Vibrante -->
                      <span class="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-extrabold bg-rose-100 dark:bg-rose-950/80 border border-rose-300 dark:border-rose-700 text-rose-600 dark:text-rose-400 uppercase tracking-wider shadow-2xs">
                        <span class="i-lucide-alert-triangle size-3.5 text-rose-600 dark:text-rose-400 shrink-0" />
                        [AÇÃO NECESSÁRIA]
                      </span>

                      <!-- Badge Tipo de Comunicação -->
                      <span
                        v-if="item.dados.tipo_comunicacao"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-blue-100/90 dark:bg-blue-900/60 text-blue-900 dark:text-blue-200 border border-blue-300 dark:border-blue-700"
                      >
                        📋 {{ item.dados.tipo_comunicacao }}
                      </span>

                      <!-- Badge Data Limite Estimada -->
                      <span
                        v-if="item.dados.data_limite_estimada"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-amber-100/90 dark:bg-amber-950/70 border border-amber-300 dark:border-amber-700 text-amber-950 dark:text-amber-200 ml-auto"
                      >
                        <span class="i-lucide-calendar-clock size-3.5 text-amber-600 dark:text-amber-400 shrink-0" />
                        Data Limite: {{ item.dados.data_limite_estimada }}
                      </span>
                    </div>

                    <!-- Título gerado pela IA -->
                    <h4 v-if="item.dados.titulo" class="text-xs md:text-sm font-bold text-[#0a2540] dark:text-[#e0f2fe] tracking-tight leading-snug pt-0.5">
                      {{ item.dados.titulo }}
                    </h4>
                  </div>

                  <!-- 1. Resumo da Decisão Judicial (Topo) -->
                  <div v-if="item.dados.resumo_decisao" class="space-y-1">
                    <div class="flex items-center gap-1.5 font-extrabold text-[#1d63d8] dark:text-[#60a5fa] text-[11px] uppercase tracking-wider">
                      <span class="i-lucide-scale size-3.5 text-[#2563eb] dark:text-[#60a5fa] shrink-0" />
                      Resumo da Decisão:
                    </div>
                    <div class="leading-relaxed font-medium text-slate-900 dark:text-slate-100 pl-5 text-xs">
                      {{ cleanDecisionText(item.dados.resumo_decisao) }}
                    </div>
                  </div>

                  <!-- 2. Box do Próximo Passo do Advogado (Embaixo) -->
                  <div
                    v-if="item.dados.proximo_passo"
                    class="p-3 rounded-lg bg-white dark:bg-[#151922] border border-[#96c6fa] dark:border-[#2b3547] shadow-2xs space-y-1"
                  >
                    <div class="flex items-center gap-1.5 text-[11px] font-extrabold text-[#1d63d8] dark:text-[#60a5fa] uppercase tracking-wider">
                      <span class="i-lucide-arrow-right-circle size-3.5 text-[#2563eb] dark:text-[#60a5fa] shrink-0" />
                      Próximo Passo / Providência do Advogado:
                    </div>
                    <div class="text-xs text-slate-900 dark:text-white font-bold leading-relaxed">
                      {{ item.dados.proximo_passo }}
                    </div>
                  </div>

                  <!-- 3. Metadados Rápidos: Cliente, Vara e Dias Concedidos -->
                  <div class="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs pt-1 border-t border-[#bcdcfe]/60 dark:border-[#2b3547]/60">
                    <div v-if="item.dados.parte_autora" class="flex items-center gap-1.5 text-slate-800 dark:text-slate-200">
                      <span class="i-lucide-user size-3.5 text-[#2563eb] dark:text-[#60a5fa] shrink-0" />
                      <span>Cliente: <strong class="font-bold underline text-[#0a2540] dark:text-[#93c5fd]">{{ item.dados.parte_autora }}</strong></span>
                    </div>
                    <div v-if="item.dados.orgao_vara" class="flex items-center gap-1.5 text-slate-700 dark:text-slate-300 truncate max-w-sm">
                      <span class="i-lucide-landmark size-3.5 text-slate-500 dark:text-slate-400 shrink-0" />
                      <span>{{ item.dados.orgao_vara }}</span>
                    </div>
                    <div v-if="item.dados.prazo_concedido && item.dados.prazo_concedido !== '0'" class="flex items-center gap-1 font-bold text-amber-900 dark:text-amber-300 ml-auto">
                      <span class="i-lucide-hourglass size-3.5 text-amber-600 dark:text-amber-400 shrink-0" />
                      <span>{{ item.dados.prazo_concedido }} dias concedidos</span>
                    </div>
                  </div>
                </div>

                <!-- 3. Caso: HOMOLOGAÇÃO / EXPEDIÇÃO DE PAGAMENTO (Fundo Verde Suave — Ótima Notícia!) -->
                <div v-else-if="isHomologacao(item)" class="p-3.5 space-y-3 text-xs">
                  <!-- Header: Badge + Tipo -->
                  <div class="space-y-1.5">
                    <div class="flex items-center gap-2 flex-wrap">
                      <!-- Badge Homologação Verde -->
                      <span class="inline-flex items-center gap-1.5 px-3 py-0.5 rounded-full text-[11px] font-extrabold bg-emerald-100 dark:bg-emerald-950/80 border border-emerald-400 dark:border-emerald-700 text-emerald-800 dark:text-emerald-300 uppercase tracking-wider shadow-2xs">
                        <span class="i-lucide-badge-check size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                        [HOMOLOGAÇÃO / PAGAMENTO]
                      </span>

                      <!-- Badge Tipo de Comunicação -->
                      <span
                        v-if="item.dados.tipo_comunicacao"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-emerald-50 dark:bg-emerald-900/40 text-emerald-900 dark:text-emerald-200 border border-emerald-200 dark:border-emerald-800"
                      >
                        📋 {{ item.dados.tipo_comunicacao }}
                      </span>

                      <!-- Badge Data Limite (se houver) -->
                      <span
                        v-if="item.dados.data_limite_estimada"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-white/80 dark:bg-black/40 border border-emerald-300 dark:border-emerald-800 text-emerald-950 dark:text-emerald-200 ml-auto"
                      >
                        <span class="i-lucide-calendar-clock size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                        Data Limite: {{ item.dados.data_limite_estimada }}
                      </span>
                    </div>

                    <!-- Título gerado pela IA -->
                    <h4 v-if="item.dados.titulo" class="text-xs md:text-sm font-bold text-emerald-950 dark:text-emerald-100 tracking-tight leading-snug pt-0.5">
                      {{ item.dados.titulo }}
                    </h4>
                  </div>

                  <!-- Resumo da Decisão -->
                  <div v-if="item.dados.resumo_decisao" class="space-y-1">
                    <div class="flex items-center gap-1.5 font-extrabold text-emerald-800 dark:text-emerald-300 text-[11px] uppercase tracking-wider">
                      <span class="i-lucide-scale size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                      Resumo da Decisão:
                    </div>
                    <div class="leading-relaxed font-medium text-emerald-950 dark:text-emerald-100 pl-5 text-xs">
                      {{ cleanDecisionText(item.dados.resumo_decisao) }}
                    </div>
                  </div>

                  <!-- Próximo Passo -->
                  <div
                    v-if="item.dados.proximo_passo"
                    class="p-3 rounded-lg bg-white/90 dark:bg-[#091a12] border border-emerald-200 dark:border-[#1a4731] shadow-2xs space-y-1"
                  >
                    <div class="flex items-center gap-1.5 text-[11px] font-extrabold text-emerald-800 dark:text-emerald-300 uppercase tracking-wider">
                      <span class="i-lucide-arrow-right-circle size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                      Próximo Passo / Providência do Advogado:
                    </div>
                    <div class="text-xs text-emerald-950 dark:text-emerald-50 font-bold leading-relaxed">
                      {{ item.dados.proximo_passo }}
                    </div>
                  </div>

                  <!-- Metadados: Cliente, Vara -->
                  <div class="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs pt-1 border-t border-emerald-300/60 dark:border-emerald-900/60">
                    <div v-if="item.dados.parte_autora" class="flex items-center gap-1.5 text-emerald-950 dark:text-emerald-200">
                      <span class="i-lucide-user size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                      <span>Cliente: <strong class="font-black underline text-emerald-950 dark:text-emerald-100">{{ item.dados.parte_autora }}</strong></span>
                    </div>
                    <div v-if="item.dados.orgao_vara" class="flex items-center gap-1.5 text-emerald-800 dark:text-emerald-300 truncate max-w-sm">
                      <span class="i-lucide-landmark size-3.5 text-emerald-600 dark:text-emerald-400 shrink-0" />
                      <span>{{ item.dados.orgao_vara }}</span>
                    </div>
                  </div>
                </div>

                <!-- 4. Caso: Mera Movimentação (Discreto, Sutil e com Resumo da Decisão) -->

                <div v-else class="p-3.5 space-y-2.5 text-xs">
                  <!-- Header: Badges & Identificação -->
                  <div class="flex items-center justify-between gap-2 flex-wrap">
                    <div class="flex items-center gap-2 flex-wrap">
                      <span class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-[10px] font-bold bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-slate-700 uppercase tracking-wider">
                        <span class="i-lucide-info size-3 text-slate-500 shrink-0" />
                        [MERA MOVIMENTAÇÃO]
                      </span>
                      <span
                        v-if="item.dados.tipo_comunicacao"
                        class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md text-[11px] font-bold bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-slate-700"
                      >
                        📋 {{ item.dados.tipo_comunicacao }}
                      </span>
                      <span class="text-slate-500 dark:text-slate-400 text-[11px] hidden sm:inline">• Sem prazo fatal para o cliente</span>
                    </div>

                    <!-- Cliente / Parte Autora -->
                    <div v-if="item.dados.parte_autora" class="flex items-center gap-1.5 text-slate-700 dark:text-slate-300 text-xs ml-auto truncate max-w-sm">
                      <span class="i-lucide-user size-3.5 text-slate-400 shrink-0" />
                      <span>Cliente: <strong class="font-semibold text-slate-900 dark:text-slate-100">{{ item.dados.parte_autora }}</strong></span>
                    </div>
                  </div>

                  <!-- Título gerado pela IA (se houver) -->
                  <h4 v-if="item.dados.titulo" class="text-xs md:text-sm font-bold text-slate-800 dark:text-slate-200 tracking-tight leading-snug pt-0.5">
                    {{ item.dados.titulo }}
                  </h4>

                  <!-- Resumo da Decisão Judicial (Mera Movimentação) -->
                  <div v-if="getResumoDecisao(item)" class="space-y-1 bg-white/70 dark:bg-[#151922]/70 p-3 rounded-lg border border-slate-200/80 dark:border-[#2b3547]/80 shadow-2xs">
                    <div class="flex items-center gap-1.5 font-bold text-slate-700 dark:text-slate-300 text-[11px] uppercase tracking-wider">
                      <span class="i-lucide-scale size-3.5 text-slate-500 dark:text-slate-400 shrink-0" />
                      Resumo da Decisão:
                    </div>
                    <div class="leading-relaxed font-normal text-slate-800 dark:text-slate-200 text-xs pl-5">
                      {{ getResumoDecisao(item) }}
                    </div>
                  </div>

                  <!-- Metadados de Órgão / Vara -->
                  <div v-if="item.dados.orgao_vara" class="flex items-center gap-1.5 text-slate-500 dark:text-slate-400 text-[11px] pt-0.5">
                    <span class="i-lucide-landmark size-3 text-slate-400 shrink-0" />
                    <span>{{ item.dados.orgao_vara }}</span>
                  </div>
                </div>
              </div>

              <!-- Full Text / Raw Publication -->

              <div

                :class="[

                  'text-xs leading-relaxed whitespace-pre-line font-normal',

                  expandedIds.includes(item.id) ? '' : 'line-clamp-3',

                  item.is_read ? 'text-slate-600 dark:text-slate-400' : 'text-slate-800 dark:text-slate-200 font-normal'

                ]"

              >

                {{ item.full_text }}

              </div>



              <!-- Publication ID & Metadata Footer -->

              <div v-if="expandedIds.includes(item.id)" class="mt-3 pt-2 border-t border-black/10 flex flex-wrap items-center justify-between text-xs" :class="item.is_read ? 'text-n-slate-10' : 'text-slate-700'">

                <span>Publicação ID: {{ item.publication_id || '-' }}</span>

                <div v-if="item.dados && item.dados.advogado_autora" class="truncate max-w-md">

                  Adv: {{ item.dados.advogado_autora }}

                </div>

              </div>



              <!-- Bottom Action Row -->

              <div class="mt-3 flex items-center justify-between border-t border-black/10 pt-2.5">

                <div class="flex items-center gap-1.5">

                  <span

                    v-if="item.conversation_id"

                    class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-50 dark:bg-[#064e3b]/50 text-emerald-700 dark:text-emerald-400 border border-emerald-300 dark:border-emerald-500/40 shadow-xs"

                  >

                    <span class="i-lucide-check size-3.5 text-emerald-600 dark:text-emerald-400 font-bold" />

                    <span>Vinculado à conversa #{{ item.conversation_id }}</span>

                  </span>

                  <span

                    v-else

                    class="text-xs text-slate-400 dark:text-slate-500 flex items-center gap-1.5 font-medium"

                  >

                    <span class="size-2 rounded-full bg-slate-400 dark:bg-slate-600" />

                    <span>Não vinculado</span>

                  </span>

                </div>



                <button

                  @click="openLinkModal(item)"

                  class="text-xs font-semibold text-[#2781F6] hover:underline cursor-pointer flex items-center gap-1"

                >

                  <span class="i-lucide-link size-3.5" />

                  Criar / Vincular a uma conversa

                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>



    <!-- Right Sidebar Area: Interactive Calendar & Filters -->

    <!-- Mobile Slide-over Drawer: Interactive Calendar & Filters -->

    <transition name="drawer-fade">

      <div

        v-if="showMobileFilters"

        class="fixed inset-0 bg-black/60 z-40 lg:hidden backdrop-blur-md"

        @click="showMobileFilters = false"

      />

    </transition>

    <transition name="drawer-slide">

      <div

        v-if="showMobileFilters"

        class="fixed inset-y-0 right-0 w-full sm:w-80 max-w-[88vw] bg-n-solid-1 z-50 shadow-2xl flex flex-col lg:hidden border-l border-n-weak"

      >

        <div class="p-4 border-b border-n-weak font-bold text-sm text-n-slate-12 flex items-center justify-between bg-n-solid-2">

          <div class="flex items-center gap-2">

            <span class="i-lucide-filter size-4 text-[#2781F6]" />

            <span>Filtros & Calendário</span>

          </div>

          <button

            @click="showMobileFilters = false"

            class="p-1 rounded-lg hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12 cursor-pointer"

          >

            <span class="i-lucide-x size-5" />

          </button>

        </div>



      <div class="p-4 border-b border-n-weak font-semibold text-sm text-n-slate-12 flex items-center justify-between">

        <span>Filtrar por:</span>

        <span v-if="hasActiveFilters" @click="clearFilters" class="text-xs text-[#2781F6] font-medium cursor-pointer hover:underline">

          Restaurar

        </span>

      </div>



      <div class="p-4 flex-1 overflow-y-auto space-y-6 no-scrollbar">

        <!-- Interactive Monthly Calendar Widget -->

        <div class="border border-n-weak rounded-xl p-3 bg-n-solid-2 shadow-sm space-y-3">

          <!-- Calendar Header -->

          <div class="flex items-center justify-between px-1">

            <button

              @click="prevMonth"

              class="p-1 rounded-md hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12 cursor-pointer"

            >

              <span class="i-lucide-chevron-left size-4" />

            </button>

            <div class="text-xs font-bold text-n-slate-12 capitalize">

              {{ currentMonthLabel }}

            </div>

            <button

              @click="nextMonth"

              class="p-1 rounded-md hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12 cursor-pointer"

            >

              <span class="i-lucide-chevron-right size-4" />

            </button>

          </div>



          <!-- Calendar Days Grid -->

          <div class="grid grid-cols-7 gap-1 text-center text-xs">

            <span v-for="d in ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']" :key="d" class="font-semibold text-n-slate-10 text-[10px]">

              {{ d }}

            </span>

            <button

              v-for="cell in calendarDays"

              :key="cell.dateStr"

              @click="selectCalendarDate(cell.dateStr)"

              :disabled="!cell.isCurrentMonth"

              :class="[

                'h-8 rounded-lg flex flex-col items-center justify-center text-xs font-medium relative transition-all cursor-pointer',

                !cell.isCurrentMonth ? 'opacity-20 pointer-events-none' : '',

                selectedDate === cell.dateStr

                  ? 'bg-[#2781F6] text-white font-bold shadow-sm'

                  : cell.isToday

                    ? 'border border-[#2781F6] text-[#2781F6] font-bold'

                    : 'hover:bg-n-alpha-2 text-n-slate-12'

              ]"

            >

              <span>{{ cell.dayNum }}</span>

              <!-- Publication Dot Indicator -->

              <span

                v-if="summary.calendar_summary && summary.calendar_summary[cell.dateStr]"

                class="size-1 rounded-full absolute bottom-1"

                :class="summary.calendar_summary[cell.dateStr].unread > 0 ? 'bg-amber-400' : 'bg-emerald-400'"

              />

            </button>

          </div>



          <!-- Calendar Legend -->

          <div class="flex items-center justify-between text-[10px] text-n-slate-10 pt-2 border-t border-n-weak">

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-emerald-400" />

              <span>Lida</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-amber-400" />

              <span>Não Lida</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full border border-[#2781F6]" />

              <span>Hoje</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-[#2781F6]" />

              <span>Seleção</span>

            </div>

          </div>

        </div>



        <!-- Period Filter -->

        <div class="space-y-2">

          <label class="text-xs font-semibold text-n-slate-11">Selecione uma data ou período:</label>

          <div class="grid grid-cols-2 gap-2">

            <div>

              <span class="text-[10px] text-n-slate-10 block mb-1">Data Inicial</span>

              <input

                v-model="dateStart"

                @change="fetchIntimacoes"

                type="date"

                class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

              />

            </div>

            <div>

              <span class="text-[10px] text-n-slate-10 block mb-1">Data Final</span>

              <input

                v-model="dateEnd"

                @change="fetchIntimacoes"

                type="date"

                class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

              />

            </div>

          </div>

        </div>



        <!-- Status Checkboxes -->

        <div class="space-y-2.5">

          <label class="text-xs font-semibold text-n-slate-11">Filtrar a lista de intimações por:</label>

          <div class="grid grid-cols-2 gap-2.5">

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterLidas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Lidas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterNaoLidas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Não lidas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterFavoritas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Favoritas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterComPrazo"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Com prazo

            </label>

          </div>

        </div>



        <!-- Tribunais Filter -->

        <div class="space-y-2">

          <label class="text-xs font-semibold text-n-slate-11">Tribunais</label>

          <select

            v-model="tribunal"

            @change="fetchIntimacoes"

            class="w-full px-3 py-2 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6] cursor-pointer"

          >

            <option value="all">Todos os Tribunais</option>

            <option value="TJSP">TJSP - Tribunal de Justiça de SP</option>

            <option value="TJPR">TJPR - Tribunal de Justiça do PR</option>

            <option value="TRT">TRT - Tribunal Regional do Trabalho</option>

            <option value="TRF">TRF - Tribunal Regional Federal</option>

            <option value="STJ">STJ - Superior Tribunal de Justiça</option>

            <option value="STF">STF - Supremo Tribunal Federal</option>

          </select>

        </div>

      </div>



      <!-- Clear Filters Button -->

      <div class="p-4 border-t border-n-weak">

        <button

          @click="clearFilters"

          class="w-full py-2 text-xs font-semibold rounded-lg border border-red-500/40 text-red-600 hover:bg-red-500/10 dark:text-red-400 transition-all cursor-pointer"

        >

          LIMPAR FILTROS

        </button>

      </div>



        <div class="p-4 border-t border-n-weak bg-n-solid-2">

          <button

            @click="showMobileFilters = false"

            class="w-full py-2.5 px-4 bg-[#2781F6] hover:bg-[#2781F6]/90 text-white font-bold text-xs rounded-xl shadow-md cursor-pointer transition-all"

          >

            Ver Intimações ({{ meta.total_count || 0 }})

          </button>

        </div>

      </div>

    </transition>

    <!-- Right Sidebar Area (Desktop only): Interactive Calendar & Filters -->

    <div class="hidden lg:flex lg:w-80 bg-n-solid-1 border-l border-n-weak flex-col flex-shrink-0">

      <div class="p-4 border-b border-n-weak font-semibold text-sm text-n-slate-12 flex items-center justify-between">

        <span>Filtrar por:</span>

        <span v-if="hasActiveFilters" @click="clearFilters" class="text-xs text-[#2781F6] font-medium cursor-pointer hover:underline">

          Restaurar

        </span>

      </div>



      <div class="p-4 flex-1 overflow-y-auto space-y-6 no-scrollbar">

        <!-- Interactive Monthly Calendar Widget -->

        <div class="border border-n-weak rounded-xl p-3 bg-n-solid-2 shadow-sm space-y-3">

          <!-- Calendar Header -->

          <div class="flex items-center justify-between px-1">

            <button

              @click="prevMonth"

              class="p-1 rounded-md hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12 cursor-pointer"

            >

              <span class="i-lucide-chevron-left size-4" />

            </button>

            <div class="text-xs font-bold text-n-slate-12 capitalize">

              {{ currentMonthLabel }}

            </div>

            <button

              @click="nextMonth"

              class="p-1 rounded-md hover:bg-n-alpha-2 text-n-slate-11 hover:text-n-slate-12 cursor-pointer"

            >

              <span class="i-lucide-chevron-right size-4" />

            </button>

          </div>



          <!-- Calendar Days Grid -->

          <div class="grid grid-cols-7 gap-1 text-center text-xs">

            <span v-for="d in ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']" :key="d" class="font-semibold text-n-slate-10 text-[10px]">

              {{ d }}

            </span>

            <button

              v-for="cell in calendarDays"

              :key="cell.dateStr"

              @click="selectCalendarDate(cell.dateStr)"

              :disabled="!cell.isCurrentMonth"

              :class="[

                'h-8 rounded-lg flex flex-col items-center justify-center text-xs font-medium relative transition-all cursor-pointer',

                !cell.isCurrentMonth ? 'opacity-20 pointer-events-none' : '',

                selectedDate === cell.dateStr

                  ? 'bg-[#2781F6] text-white font-bold shadow-sm'

                  : cell.isToday

                    ? 'border border-[#2781F6] text-[#2781F6] font-bold'

                    : 'hover:bg-n-alpha-2 text-n-slate-12'

              ]"

            >

              <span>{{ cell.dayNum }}</span>

              <!-- Publication Dot Indicator -->

              <span

                v-if="summary.calendar_summary && summary.calendar_summary[cell.dateStr]"

                class="size-1 rounded-full absolute bottom-1"

                :class="summary.calendar_summary[cell.dateStr].unread > 0 ? 'bg-amber-400' : 'bg-emerald-400'"

              />

            </button>

          </div>



          <!-- Calendar Legend -->

          <div class="flex items-center justify-between text-[10px] text-n-slate-10 pt-2 border-t border-n-weak">

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-emerald-400" />

              <span>Lida</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-amber-400" />

              <span>Não Lida</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full border border-[#2781F6]" />

              <span>Hoje</span>

            </div>

            <div class="flex items-center gap-1">

              <span class="size-2 rounded-full bg-[#2781F6]" />

              <span>Seleção</span>

            </div>

          </div>

        </div>



        <!-- Period Filter -->

        <div class="space-y-2">

          <label class="text-xs font-semibold text-n-slate-11">Selecione uma data ou período:</label>

          <div class="grid grid-cols-2 gap-2">

            <div>

              <span class="text-[10px] text-n-slate-10 block mb-1">Data Inicial</span>

              <input

                v-model="dateStart"

                @change="fetchIntimacoes"

                type="date"

                class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

              />

            </div>

            <div>

              <span class="text-[10px] text-n-slate-10 block mb-1">Data Final</span>

              <input

                v-model="dateEnd"

                @change="fetchIntimacoes"

                type="date"

                class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

              />

            </div>

          </div>

        </div>



        <!-- Status Checkboxes -->

        <div class="space-y-2.5">

          <label class="text-xs font-semibold text-n-slate-11">Filtrar a lista de intimações por:</label>

          <div class="grid grid-cols-2 gap-2.5">

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterLidas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Lidas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterNaoLidas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Não lidas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterFavoritas"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Favoritas

            </label>

            <label class="flex items-center gap-2 text-xs text-n-slate-12 cursor-pointer">

              <input

                type="checkbox"

                v-model="filterComPrazo"

                @change="fetchIntimacoes"

                class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]"

              />

              Com prazo

            </label>

          </div>

        </div>



        <!-- Tribunais Filter -->

        <div class="space-y-2">

          <label class="text-xs font-semibold text-n-slate-11">Tribunais</label>

          <select

            v-model="tribunal"

            @change="fetchIntimacoes"

            class="w-full px-3 py-2 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6] cursor-pointer"

          >

            <option value="all">Todos os Tribunais</option>

            <option value="TJSP">TJSP - Tribunal de Justiça de SP</option>

            <option value="TJPR">TJPR - Tribunal de Justiça do PR</option>

            <option value="TRT">TRT - Tribunal Regional do Trabalho</option>

            <option value="TRF">TRF - Tribunal Regional Federal</option>

            <option value="STJ">STJ - Superior Tribunal de Justiça</option>

            <option value="STF">STF - Supremo Tribunal Federal</option>

          </select>

        </div>

      </div>



      <!-- Clear Filters Button -->

      <div class="p-4 border-t border-n-weak">

        <button

          @click="clearFilters"

          class="w-full py-2 text-xs font-semibold rounded-lg border border-red-500/40 text-red-600 hover:bg-red-500/10 dark:text-red-400 transition-all cursor-pointer"

        >

          LIMPAR FILTROS

        </button>

      </div>

    </div>

    
    <!-- Modal: Gerenciar Advogados Monitorados -->
    <div v-if="showLawyersModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">
      <div class="bg-white dark:bg-[#141517] border border-slate-200 dark:border-slate-800 rounded-2xl w-full max-w-lg shadow-2xl overflow-hidden flex flex-col max-h-[85vh] text-slate-800 dark:text-slate-200">
        <!-- Header -->
        <div class="flex items-start justify-between pb-3 px-6 pt-5 border-b border-slate-100 dark:border-slate-800">
          <div>
            <h3 class="text-base font-semibold text-slate-900 dark:text-slate-100 flex items-center gap-2">
              <span class="i-lucide-users text-[#1F93FF] size-5" />
              <span>Advogados Monitorados do Escritório</span>
            </h3>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Cadastre os advogados deste escritório para filtragem rápida e organização de publicações.
            </p>
          </div>
          <button @click="showLawyersModal = false" class="p-1 rounded-md text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 cursor-pointer">
            <span class="i-lucide-x size-4" />
          </button>
        </div>

        <!-- Body -->
        <div class="flex-1 overflow-y-auto px-6 py-4 space-y-4">
          <!-- Lista Atual -->
          <div class="space-y-2">
            <span class="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
              Advogados Ativos ({{ registeredLawyersList.length }})
            </span>
            <div class="space-y-2 max-h-52 overflow-y-auto pr-1">
              <div
                v-for="(adv, idx) in registeredLawyersList"
                :key="adv.id || idx"
                class="flex items-center justify-between p-2.5 rounded-lg bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700"
              >
                <div class="flex items-center gap-2">
                  <span class="text-sm font-medium text-slate-900 dark:text-slate-100">{{ adv.name }}</span>
                  <span v-if="adv.is_primary" class="px-2 py-0.5 rounded text-[10px] font-bold bg-amber-100 text-amber-900 dark:bg-amber-950/60 dark:text-amber-300">
                    Principal
                  </span>
                </div>
                <button
                  @click="removeLawyer(idx)"
                  type="button"
                  class="p-1 text-slate-400 hover:text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/30 rounded transition-colors cursor-pointer"
                  title="Remover advogado"
                >
                  <span class="i-lucide-trash-2 size-4" />
                </button>
              </div>
            </div>
          </div>

          <!-- Formulário de Adição Rápida -->
          <div class="p-3.5 rounded-xl bg-[#1F93FF]/5 border border-[#1F93FF]/25 space-y-3">
            <span class="text-xs font-semibold text-slate-900 dark:text-slate-100 block">
              + Adicionar Novo Advogado
            </span>
            <div class="flex flex-col sm:flex-row gap-2">
              <input
                v-model="newLawyerName"
                type="text"
                placeholder="Nome completo (ex: Stefany Maria Barrivieira)"
                class="flex-1 h-9 px-3 text-xs bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-900 dark:text-slate-100 focus:outline-none focus:border-[#1F93FF]"
                @keyup.enter="addNewLawyer"
              />
              <button
                @click="addNewLawyer"
                :disabled="!newLawyerName.trim()"
                type="button"
                class="px-4 py-2 text-xs font-semibold rounded-lg bg-[#1F93FF] hover:bg-[#1877d2] text-white transition-colors cursor-pointer disabled:opacity-50"
              >
                Adicionar
              </button>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="flex items-center justify-end gap-2.5 px-6 py-3 border-t border-slate-100 dark:border-slate-800 bg-white dark:bg-[#141517]">
          <button
            @click="showLawyersModal = false"
            class="px-4 py-2 text-xs font-medium rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors cursor-pointer"
          >
            Fechar
          </button>
          <button
            @click="saveLawyersList"
            :disabled="isSavingLawyers"
            class="px-5 py-2 text-xs font-medium rounded-lg bg-[#1F93FF] hover:bg-[#1877d2] text-white transition-colors cursor-pointer disabled:opacity-50"
          >
            {{ isSavingLawyers ? 'Salvando...' : 'Salvar Alterações' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Webhook & N8N Integration -->

    <div v-if="showWebhookModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">

      <div class="bg-n-solid-1 border border-n-weak rounded-2xl w-full max-w-lg shadow-2xl p-6 space-y-4">

        <div class="flex items-center justify-between border-b border-n-weak pb-3">

          <div class="flex items-center gap-2">

            <span class="i-lucide-webhook size-5 text-[#2781F6]" />

            <h3 class="text-sm font-bold text-n-slate-12">Integração Webhook N8N / API</h3>

          </div>

          <button @click="showWebhookModal = false" class="p-1 rounded-md text-n-slate-10 hover:text-n-slate-12 hover:bg-n-alpha-2 cursor-pointer">

            <span class="i-lucide-x size-4" />

          </button>

        </div>



        <div class="space-y-3 text-xs text-n-slate-11 leading-relaxed">

          <p>

            Configure seu nó <strong>HTTP Request</strong> no N8N apontando para o endpoint nativo do Chatwoot Zéti Desk:

          </p>



          <div class="p-3.5 rounded-xl bg-slate-50 dark:bg-slate-800/60 border border-slate-200 dark:border-slate-700 space-y-3">
            <div>
              <div class="flex items-center justify-between">
                <span class="text-[10px] text-slate-500 uppercase font-bold">Método & URL (Conta ID #{{ currentAccountId }}):</span>
                <button @click="copyToClipboard(`https://app.zetijuris.com.br/api/v1/intimacoes`)" class="text-xs font-semibold text-[#1F93FF] hover:underline cursor-pointer">
                  Copiar URL
                </button>
              </div>
              <div class="mt-1 font-mono text-xs text-emerald-600 dark:text-emerald-400 break-all select-all p-2 rounded bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
                POST https://app.zetijuris.com.br/api/v1/intimacoes
              </div>
            </div>

            <div class="pt-2 border-t border-slate-200 dark:border-slate-700">
              <div class="flex items-center justify-between">
                <span class="text-[10px] text-slate-500 uppercase font-bold">Header de Autorização:</span>
                <button @click="copyToClipboard(`Bearer ${currentUserAccessToken}`)" class="text-xs font-semibold text-[#1F93FF] hover:underline cursor-pointer">
                  Copiar Header
                </button>
              </div>
              <div class="mt-1 font-mono text-xs text-slate-800 dark:text-slate-200 break-all select-all p-2 rounded bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
                Authorization: Bearer {{ currentUserAccessToken }}
              </div>
            </div>
          </div>



          <p class="text-[11px]">

            O Chatwoot verifica automaticamente o <code class="px-1 py-0.5 bg-n-alpha-2 rounded">publication_id</code> e previne duplicidades retornando <code class="px-1 py-0.5 bg-n-alpha-2 rounded">duplicate: true</code> quando já existe.

          </p>

        </div>



        <div class="flex justify-end pt-2">

          <button

            @click="showWebhookModal = false"

            class="px-4 py-2 text-xs font-semibold rounded-lg bg-[#2781F6] text-white hover:bg-[#2781F6]/90 cursor-pointer"

          >

            Entendido

          </button>

        </div>

      </div>

    </div>



    <!-- Enhanced Modal: Criar / Vincular a uma Conversa / Processo -->

    <div v-if="showLinkModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-md">

      <div class="bg-n-solid-1 border border-n-weak rounded-2xl w-full max-w-xl shadow-2xl p-6 space-y-4">

        <div class="flex items-center justify-between border-b border-n-weak pb-3">

          <div class="flex items-center gap-2">

            <span class="i-lucide-link size-5 text-[#2781F6]" />

            <h3 class="text-sm font-bold text-n-slate-12">Vincular Intimação ao Cliente / Atendimento</h3>

          </div>

          <button @click="showLinkModal = false" class="p-1 rounded-md text-n-slate-10 hover:text-n-slate-12 hover:bg-n-alpha-2 cursor-pointer">

            <span class="i-lucide-x size-4" />

          </button>

        </div>



        <!-- Intimacao Header Summary -->

        <div class="p-3 rounded-lg bg-n-solid-2 border border-n-weak space-y-1 text-xs">

          <div class="flex items-center justify-between font-semibold text-n-slate-12">

            <span>Processo: {{ selectedItemForLink?.process_number || '-' }}</span>

            <span class="text-[#2781F6]">{{ selectedItemForLink?.jornal || 'DJEN' }}</span>

          </div>

          <div v-if="selectedItemForLink?.dados?.parte_autora" class="text-n-slate-11 truncate">

            Autor(a): {{ selectedItemForLink?.dados?.parte_autora }}

          </div>

        </div>



        <!-- Tabs inside Modal -->

        <div class="flex border-b border-n-weak gap-4 text-xs font-semibold">

          <button

            @click="linkModalTab = 'search'"

            :class="[

              'pb-2 border-b-2 cursor-pointer transition-all',

              linkModalTab === 'search' ? 'border-[#2781F6] text-[#2781F6]' : 'border-transparent text-n-slate-11 hover:text-n-slate-12'

            ]"

          >

            🔍 Buscar por Nome / Processo / CPF

          </button>

          <button

            @click="linkModalTab = 'manual'"

            :class="[

              'pb-2 border-b-2 cursor-pointer transition-all',

              linkModalTab === 'manual' ? 'border-[#2781F6] text-[#2781F6]' : 'border-transparent text-n-slate-11 hover:text-n-slate-12'

            ]"

          >

            ✏️ Informar ID Manual

          </button>

        </div>



        <!-- Search Tab -->

        <div v-if="linkModalTab === 'search'" class="space-y-3 text-xs">

          <div class="relative">

            <span class="i-lucide-search absolute left-3 top-1/2 -translate-y-1/2 size-4 text-n-slate-10" />

            <input

              v-model="contactSearchQuery"

              @input="onSearchContacts"

              type="text"

              placeholder="Digite o nome do cliente, telefone, CPF ou nº do processo..."

              class="w-full pl-9 pr-4 py-2 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

            />

          </div>



          <!-- Search Results List -->

          <div class="max-h-48 overflow-y-auto space-y-1.5 border border-n-weak rounded-lg p-2 bg-n-solid-2">

            <div v-if="isSearchingContacts" class="text-center p-4 text-n-slate-10 flex items-center justify-center gap-2">

              <span class="i-lucide-loader-2 size-4 animate-spin text-[#2781F6]" />

              Buscando nos contatos e detalhes de processos...

            </div>

            <div v-else-if="contactResults.length === 0" class="text-center p-4 text-n-slate-10">

              Digite ao menos 2 caracteres para buscar.

            </div>

            <div

              v-else

              v-for="target in contactResults"

              :key="target.contact_id || target.conversation_id"

              @click="selectedTargetForLink = target"

              :class="[

                'p-2.5 rounded-lg flex items-center justify-between cursor-pointer transition-all border',

                selectedTargetForLink?.contact_id === target.contact_id || (target.conversation_id && selectedTargetForLink?.conversation_id === target.conversation_id)

                  ? 'bg-[#2781F6] text-white border-[#2781F6] font-semibold'

                  : 'bg-n-background border-n-weak hover:bg-n-alpha-2 text-n-slate-12'

              ]"

            >

              <div class="flex items-center gap-2.5 truncate">

                <div class="size-8 rounded-full bg-black/10 flex items-center justify-center text-xs font-bold shrink-0">

                  {{ target.name ? target.name.charAt(0).toUpperCase() : 'C' }}

                </div>

                <div class="truncate">

                  <div class="font-bold text-xs truncate">{{ target.name || 'Sem nome' }}</div>

                  <div class="text-[11px] opacity-90 flex items-center gap-2 flex-wrap">

                    <span>{{ target.phone_number || target.email || `ID #${target.contact_id}` }}</span>

                    <span v-if="target.conversation_id" class="px-1.5 py-0.2 bg-black/20 rounded text-[10px]">Chat #{{ target.conversation_id }}</span>

                    <span v-if="target.processes && target.processes.length > 0" class="px-1.5 py-0.2 bg-emerald-500/20 text-emerald-800 dark:text-emerald-300 rounded text-[10px]">

                      Proc: {{ target.processes[0] }}

                    </span>

                  </div>

                </div>

              </div>

              <span class="i-lucide-check-circle size-4" :class="selectedTargetForLink?.contact_id === target.contact_id ? 'opacity-100' : 'opacity-0'" />

            </div>

          </div>

        </div>



        <!-- Manual Tab -->

        <div v-else class="space-y-3 text-xs">

          <div class="space-y-1">

            <label class="font-medium text-n-slate-12">ID Numérico da Conversa no Chatwoot:</label>

            <input

              v-model="linkConversationId"

              type="number"

              placeholder="Ex: 1042"

              class="w-full px-3 py-2 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

            />

          </div>

        </div>



        <!-- Options: Tags & Internal Note & Outgoing WhatsApp -->



        <!-- Configuração Completa do Prazo Processual -->

        <div class="border border-n-weak rounded-xl p-3.5 bg-n-solid-2 space-y-3">

          <label class="flex items-center gap-2 text-xs font-bold text-n-slate-12 cursor-pointer select-none">

            <input type="checkbox" v-model="linkCreateTarefa" class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]" />

            <span>📅 Criar Prazo / Tarefa no Calendário</span>

          </label>



          <div v-if="linkCreateTarefa" class="space-y-2.5 pt-1">

            <div class="grid grid-cols-2 gap-2 text-xs">

              <div class="space-y-1">

                <label class="font-bold text-n-slate-12 text-[11px]">Data Limite do Prazo *</label>

                <input

                  v-model="linkTarefaDueDate"

                  type="date"

                  required

                  class="w-full px-2.5 py-1.5 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

                />

              </div>



              <div class="space-y-1">

                <label class="font-bold text-n-slate-12 text-[11px]">Hora Limite</label>

                <input

                  v-model="linkTarefaDueTime"

                  type="time"

                  class="w-full px-2.5 py-1.5 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

                />

              </div>

            </div>



            <div class="grid grid-cols-2 gap-2 text-xs">

              <div class="space-y-1">

                <label class="font-bold text-n-slate-12 text-[11px]">Prioridade</label>

                <select

                  v-model="linkTarefaPriority"

                  class="w-full px-2.5 py-1.5 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6] cursor-pointer"

                >

                  <option value="urgente">🚨 Urgente</option>

                  <option value="alta">⚠️ Alta</option>

                  <option value="media">🔵 Média</option>

                  <option value="baixa">⚪ Baixa</option>

                </select>

              </div>



              <div class="space-y-1">

                <label class="font-bold text-n-slate-12 text-[11px]">👤 Agente Responsável</label>

                <select

                  v-model="linkAssignedUserId"

                  class="w-full px-2.5 py-1.5 rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6] cursor-pointer"

                >

                  <option :value="null">Nenhum agente atribuído</option>

                  <option v-for="agent in agentsList" :key="agent.id" :value="agent.id">

                    👤 {{ agent.name }}

                  </option>

                </select>

              </div>

            </div>



            <label class="flex items-center gap-2 p-2 rounded-lg bg-rose-500/10 border border-rose-500/30 text-rose-600 dark:text-rose-400 font-bold cursor-pointer select-none text-[11px]">

              <input

                type="checkbox"

                v-model="linkTarefaIsFatal"

                class="size-4 rounded text-rose-500 focus:ring-rose-500 cursor-pointer"

              />

              <span>⚡ Prazo Processual Fatal</span>

            </label>

          </div>

        </div>



        <div class="pt-2 border-t border-n-weak space-y-3 text-xs">

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">

            <!-- Option 1: Move Kanban Stage (Default: PRAZOS) -->

            <div class="p-2.5 rounded-lg bg-n-solid-2 border border-n-weak space-y-2">

              <label class="flex items-center gap-2 text-xs font-bold text-n-slate-12 cursor-pointer select-none">

                <input type="checkbox" v-model="linkMoveKanban" class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]" />

                <span>🔄 Mover para etapa do Funil</span>

              </label>

              <div v-if="linkMoveKanban" class="space-y-1">

                <select

                  v-model="linkKanbanStage"

                  class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6] cursor-pointer"

                >

                  <option v-for="stage in kanbanStagesList" :key="stage" :value="stage">

                    📌 {{ stage }}

                  </option>

                </select>

              </div>

            </div>



            <!-- Option 2: Send Private Note -->

            <div class="p-2.5 rounded-lg bg-n-solid-2 border border-n-weak flex flex-col justify-center">

              <label class="flex items-center gap-2 text-xs font-bold text-n-slate-12 cursor-pointer select-none">

                <input type="checkbox" v-model="sendPrivateNoteOnLink" class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]" />

                <span>🔒 Mandar <strong>nota privada</strong></span>

              </label>

              <span class="text-[10px] text-n-slate-10 pl-6 mt-1">Alerta a equipe interna na conversa</span>

            </div>

          </div>



          <!-- Option 3: Outgoing Client WhatsApp Message -->

          <div class="border border-n-weak rounded-xl p-3 bg-n-solid-2 space-y-2">

            <label class="flex items-center gap-2 text-xs font-semibold text-n-slate-12 cursor-pointer">

              <input type="checkbox" v-model="sendClientMessage" class="size-4 rounded border-n-strong text-[#2781F6] focus:ring-[#2781F6]" />

              <span>💬 (Opcional) Enviar WhatsApp direto para o cliente</span>

            </label>



            <div v-if="sendClientMessage" class="space-y-2 pt-1 animate-fadeIn">

              <p class="text-[11px] text-n-slate-10">

                Escreva a mensagem ou solicitação de documentos (ex: Imposto de Renda) que será enviada agora para o WhatsApp do cliente:

              </p>

              <textarea

                v-model="clientMessageText"

                rows="3"

                class="w-full p-2.5 text-xs rounded-lg border border-n-weak bg-n-background text-n-slate-12 focus:outline-none focus:border-[#2781F6]"

                placeholder="Ex: Olá! Saiu uma nova movimentação no seu processo. Precisamos que você nos envie cópia do seu Imposto de Renda atualizado para darmos andamento."

              ></textarea>

            </div>

          </div>

        </div>



        <!-- Modal Footer Actions -->

        <div class="flex justify-end gap-2 pt-2 border-t border-n-weak">

          <button

            @click="showLinkModal = false"

            class="px-4 py-2 text-xs font-medium rounded-lg bg-n-alpha-2 text-n-slate-12 hover:bg-n-alpha-3 cursor-pointer"

          >

            Cancelar

          </button>

          <button

            @click="confirmLinkConversation"

            :disabled="(linkModalTab === 'search' ? !selectedTargetForLink : !linkConversationId) || isLinking"

            class="px-4 py-2 text-xs font-semibold rounded-lg bg-[#2781F6] text-white hover:bg-[#2781F6]/90 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer flex items-center gap-1.5"

          >

            <span v-if="isLinking" class="i-lucide-loader-2 size-3.5 animate-spin" />

            <span v-else class="i-lucide-check size-3.5" />

            Confirmar e Processar

          </button>

        </div>

      </div>

    </div>

  </div>

</template>



<script setup>

import { ref, computed, onMounted, watch } from 'vue';

import { useStore } from 'vuex';

import { useMapGetter } from 'dashboard/composables/store';

import IntimacoesAPI from 'dashboard/api/intimacoes';



const store = useStore();

const currentAccountId = computed(() => store.getters['getCurrentAccountId'] || 2);
const currentUser = computed(() => store.getters['getCurrentUser'] || {});
const currentUserAccessToken = computed(() => currentUser.value?.access_token || 'wacrm_live_token');

const intimacoes = useMapGetter('intimacoes/getIntimacoes');

const meta = useMapGetter('intimacoes/getMeta');

const summary = useMapGetter('intimacoes/getSummary');

const uiFlags = useMapGetter('intimacoes/getUIFlags');



// Tabs & Filters State

const activeTab = ref('nao_lidas');
const filtroAdvogado = ref('all');
const filtroDocumentos = ref('all');

// Lawyers Management State & Methods
const showLawyersModal = ref(false);
const isSavingLawyers = ref(false);
const newLawyerName = ref('');
const registeredLawyersList = ref([
  { id: '1', name: 'VINICIUS DE MARCO FISCARELLI', key: 'vinicius_fiscarelli', role: 'Principal', is_primary: true },
  { id: '2', name: 'Vinícius Borges Furlani', key: 'vinicius_furlani', role: 'Associado', is_primary: false },
  { id: '3', name: 'Pedro Henrique Tauber Araujo', key: 'pedro_henrique', role: 'Associado', is_primary: false },
  { id: '4', name: 'Danilo Rodrigues Bizarri', key: 'danilo_bizarri', role: 'Associado', is_primary: false },
  { id: '5', name: 'BRUNO ALVES ROQUE', key: 'bruno_roque', role: 'Associado', is_primary: false },
  { id: '6', name: 'Stefany Maria Barrivieira', key: 'stefany_barrivieira', role: 'Associado', is_primary: false }
]);

const openLawyersModal = () => {
  showLawyersModal.value = true;
};

const fetchRegisteredLawyers = async () => {
  try {
    const res = await IntimacoesAPI.getAdvogados();
    if (res?.data?.advogados && res.data.advogados.length > 0) {
      registeredLawyersList.value = res.data.advogados;
    }
  } catch (err) {
    console.log('Using default lawyers list:', err);
  }
};

const addNewLawyer = () => {
  const name = newLawyerName.value.trim();
  if (!name) return;
  const key = name.toLowerCase().replace(/[^a-z0-9]/g, '_');
  registeredLawyersList.value.push({
    id: String(Date.now()),
    name: name,
    key: key,
    role: 'Associado',
    is_primary: false,
  });
  newLawyerName.value = '';
};

const removeLawyer = (idx) => {
  registeredLawyersList.value.splice(idx, 1);
};

const saveLawyersList = async () => {
  isSavingLawyers.value = true;
  try {
    await IntimacoesAPI.saveAdvogados({ advogados: registeredLawyersList.value });
    showLawyersModal.value = false;
  } catch (err) {
    console.error('Error saving lawyers list:', err);
  } finally {
    isSavingLawyers.value = false;
  }
};

const filterLidas = ref(false);

const filterNaoLidas = ref(false);

const filterFavoritas = ref(false);

const filterComPrazo = ref(false);



const getBrasiliaTodayStr = () => {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
};
const getBrasiliaDateParts = () => {
  const str = getBrasiliaTodayStr();
  const [y, m, d] = str.split('-').map(Number);
  return { year: y, month: m - 1, day: d, dateStr: str };
};
const initialDate = getBrasiliaDateParts();
const todayStr = initialDate.dateStr;

const agentsList = computed(() => store.getters['agents/getAgents'] || []);

const selectedDate = ref(todayStr);

const dateStart = ref('');

const dateEnd = ref('');

const tribunal = ref('all');

const searchQuery = ref('');



// Selection & Expand

const expandedIds = ref([]);

const selectedIds = ref([]);



// Modals

const showMobileFilters = ref(false);

const showWebhookModal = ref(false);

const showLinkModal = ref(false);

const linkModalTab = ref('search');

const selectedItemForLink = ref(null);

const linkConversationId = ref('');

const contactSearchQuery = ref('');

const contactResults = ref([]);

const isSearchingContacts = ref(false);

const selectedTargetForLink = ref(null);

const applyPrazoTag = ref(true);

const sendPrivateNoteOnLink = ref(true);

const sendClientMessage = ref(false);

const clientMessageText = ref('');

const isLinking = ref(false);

const linkAssignedUserId = ref(null);

const linkCreateTarefa = ref(true);
const linkTarefaTitle = ref('');
const linkTarefaDescription = ref('');

const linkTarefaDueDate = ref(todayStr);

const linkTarefaDueTime = ref('08:00');

const linkTarefaPriority = ref('alta');

const linkTarefaIsFatal = ref(false);

const linkMoveKanban = ref(true);

const linkKanbanStage = ref('PRAZOS');

const kanbanStagesList = ref([
  'Recepção e Qualificação',
  'Holerite',
  'Proposta',
  'Autorizado',
  'Aguardando Assinatura',
  'Analise Viabiliadade',
  'Pasta Fechada',
  'Distribuido',
  'PRAZOS',
  'Pronto para Cumprir'
]);



// Calendar Navigation State

const calendarYear = ref(new Date().getFullYear());

const calendarMonth = ref(new Date().getMonth()); // 0-indexed



const currentMonthLabel = computed(() => {

  const d = new Date(calendarYear.value, calendarMonth.value, 1);

  return d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });

});



const calendarDays = computed(() => {

  const year = calendarYear.value;

  const month = calendarMonth.value;

  

  const firstDayIndex = new Date(year, month, 1).getDay();

  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const prevMonthDays = new Date(year, month, 0).getDate();

  

  const cells = [];

  

  // Previous month trailing days

  for (let i = firstDayIndex - 1; i >= 0; i--) {

    const d = prevMonthDays - i;

    const m = month === 0 ? 12 : month;

    const y = month === 0 ? year - 1 : year;

    const dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

    cells.push({ dayNum: d, dateStr, isCurrentMonth: false, isToday: dateStr === todayStr });

  }

  

  // Current month days

  for (let d = 1; d <= daysInMonth; d++) {

    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

    cells.push({ dayNum: d, dateStr, isCurrentMonth: true, isToday: dateStr === todayStr });

  }

  

  // Next month leading days to complete grid

  const remaining = 35 - cells.length > 0 ? 35 - cells.length : 42 - cells.length;

  for (let d = 1; d <= remaining; d++) {

    const m = month === 11 ? 1 : month + 2;

    const y = month === 11 ? year + 1 : year;

    const dateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

    cells.push({ dayNum: d, dateStr, isCurrentMonth: false, isToday: dateStr === todayStr });

  }

  

  return cells;

});



const prevMonth = () => {

  if (calendarMonth.value === 0) {

    calendarMonth.value = 11;

    calendarYear.value -= 1;

  } else {

    calendarMonth.value -= 1;

  }

};



const nextMonth = () => {

  if (calendarMonth.value === 11) {

    calendarMonth.value = 0;

    calendarYear.value += 1;

  } else {

    calendarMonth.value += 1;

  }

};



const selectTab = (tab) => {

  activeTab.value = tab;

  fetchIntimacoes();
  fetchRegisteredLawyers();

};



const selectCalendarDate = (dateStr) => {

  if (selectedDate.value === dateStr) {

    selectedDate.value = '';

  } else {

    selectedDate.value = dateStr;

  }

  fetchIntimacoes();
  fetchRegisteredLawyers();

};



const hasActiveFilters = computed(() => {

  return (

    filterLidas.value ||

    filterNaoLidas.value ||

    filterFavoritas.value ||

    filterComPrazo.value ||

    dateStart.value ||

    dateEnd.value ||

    tribunal.value !== 'all' ||

    searchQuery.value ||

    (selectedDate.value && selectedDate.value !== todayStr) ||

    activeTab.value === 'favoritas'

  );

});



const getResumoDecisao = (item) => {
  if (item?.dados?.resumo_decisao) {
    return cleanDecisionText(item.dados.resumo_decisao);
  }
  const text = item?.full_text || '';
  const match = text.match(/\[MERA MOVIMENTA[ÇC][ÃA]O\]\s*:?\s*([^\n\r]+)/i);
  if (match && match[1]) {
    return cleanDecisionText(match[1]);
  }
  return '';
};

// Helper: Check if Decision is Extinção do Processo / Indeferimento da Inicial
// Helper: Check if Decision is strictly Extinção do Processo / Indeferimento da Inicial (Sem pegar despachos de emenda ou advertências futuras)
// Helper: Check if Decision has Document Request / Solicitação de Documentos
const hasDocumentRequest = (item) => {
  if (!item) return false;
  const proximo = (item.dados?.proximo_passo || '').toLowerCase();
  const resumo = (item.dados?.resumo_decisao || '').toLowerCase();
  const titulo = (item.dados?.titulo || '').toLowerCase();
  const txt = `${proximo} ${resumo} ${titulo} ${(item.full_text || '').toLowerCase()}`.trim();

  const hasAction =
    txt.includes('juntar') ||
    txt.includes('juntada') ||
    txt.includes('apresentar') ||
    txt.includes('apresentação') ||
    txt.includes('apresentacao') ||
    txt.includes('comprovar') ||
    txt.includes('comprovação') ||
    txt.includes('comprovacao') ||
    txt.includes('regularizar representação') ||
    txt.includes('regularizar representacao') ||
    txt.includes('anexar') ||
    txt.includes('fornecer') ||
    txt.includes('trazer aos autos');

  const hasDocType =
    txt.includes('document') ||
    txt.includes('comprovant') ||
    txt.includes('procuraç') ||
    txt.includes('procurac') ||
    txt.includes('declaraç') ||
    txt.includes('declarac') ||
    txt.includes('extrato') ||
    txt.includes('holerite') ||
    txt.includes('rendimento') ||
    txt.includes('registrato') ||
    txt.includes('fichas financeiras') ||
    txt.includes('certid') ||
    txt.includes('imposto de renda') ||
    txt.includes('cartão') ||
    txt.includes('cartao') ||
    txt.includes('endereço') ||
    txt.includes('endereco');

  return hasAction && hasDocType;
};

const isExtinctionOrDismissal = (item) => {
  if (!item) return false;
  const resumo = (item.dados?.resumo_decisao || '').toLowerCase();
  const titulo = (item.dados?.titulo || '').toLowerCase();
  const txt = `${titulo} ${resumo}`.trim();

  if (!txt) return false;

  // 1. Regras Negativas: NÃO aplicar se for mero despacho de prazo/emenda/advertência futura ("sob pena de", "poderá acarretar", "emendar")
  const isWarningOrDeadline =
    txt.includes('sob pena') ||
    txt.includes('poderá acarretar') ||
    txt.includes('podera acarretar') ||
    txt.includes('sob cominação') ||
    txt.includes('sob cominacao') ||
    txt.includes('emendar a petição') ||
    txt.includes('emendar a inicial') ||
    txt.includes('emenda à inicial') ||
    txt.includes('emenda a inicial');

  if (isWarningOrDeadline) return false;

  // 2. Regras Positivas Estritas: Decisão ou sentença que EFETIVAMENTE declarou a extinção ou indeferimento da inicial
  const hasDismissalInitial =
    txt.includes('petição inicial indeferida') ||
    txt.includes('peticao inicial indeferida') ||
    txt.includes('indefere a inicial e extingue') ||
    txt.includes('indefere a petição inicial e extingue') ||
    txt.includes('indefere a peticao inicial e extingue') ||
    txt.includes('indeferiu a inicial e extinguiu') ||
    txt.includes('indeferiu a petição inicial e extinguiu') ||
    txt.includes('indeferida a petição inicial') ||
    txt.includes('indeferida a peticao inicial');

  const hasExtinctionProcess =
    txt.includes('processo extinto sem resolução') ||
    txt.includes('processo extinto sem resolucao') ||
    txt.includes('processo extinto com resolução') ||
    txt.includes('processo extinto com resolucao') ||
    txt.includes('extinto o processo sem resolução') ||
    txt.includes('extinto o processo sem resolucao') ||
    txt.includes('extinto o processo com resolução') ||
    txt.includes('extinto o processo com resolucao') ||
    txt.includes('extingue o processo por ausência de emenda') ||
    txt.includes('extinguiu o processo por ausência de emenda') ||
    txt.includes('julgo extinto o processo') ||
    txt.includes('julgo extinta a ação') ||
    txt.includes('julgo extinta a acao') ||
    txt.includes('extinção do processo sem resolução') ||
    txt.includes('extinção do processo com resolução') ||
    txt.includes('extincao do processo sem resolucao') ||
    txt.includes('extincao do processo com resolucao');

  return hasDismissalInitial || hasExtinctionProcess;
};

// Helper: Check if Decision is Ação Necessária vs Mera Movimentação
const isActionRequired = (item) => {

  const full = (item.full_text || '') + ' ' + (item.dados?.resumo_decisao || '');

  const upper = full.toUpperCase();

  

  if (upper.includes('[AÇÃO NECESSÁRIA]') || upper.includes('[ACAO NECESSARIA]') || upper.includes('AÇÃO NECESSÁRIA:') || upper.includes('ACAO NECESSARIA:')) {

    return true;

  }

  if (upper.includes('[MERA MOVIMENTAÇÃO]') || upper.includes('[MERA MOVIMENTACAO]') || upper.includes('MERA MOVIMENTAÇÃO:') || upper.includes('MERA MOVIMENTACAO:')) {

    return false;

  }

  

  if (item.dados?.prazo_concedido && parseInt(item.dados.prazo_concedido, 10) > 0) {

    return true;

  }

  return false;

};

// Helper: Check if Decision is Homologação de Cálculo ou Expedição de Pagamento (VERDE)
const isHomologacao = (item) => {
  if (!item) return false;

  const dados = item.dados || {};
  const intent = (dados.intent || '').toUpperCase();
  const titulo = (dados.titulo || '').toLowerCase();
  const resumo = (dados.resumo_decisao || '').toLowerCase();
  const full = (item.full_text || '').toLowerCase();
  const txt = `${titulo} ${resumo} ${full}`;

  // 1. Descartar hipóteses puramente condicionais ou de manifestação prévia (Falsos Positivos)
  const isConditional = /(em caso de concord[âa]ncia|caso concorde|se concordar|para eventual homologa[çc][ãa]o|para futura homologa[çc][ãa]o|tornem conclusos para homologa[çc][ãa]o|conclusos para senten[çc]a|caso n[ãa]o haja impugna[çc][ãa]o|se n[ãa]o houver impugna[çc][ãa]o|para que se proceda [àa] homologa[çc][ãa]o|ap[óo]s o tr[âa]nsito, tornem conclusos|para fins de futura expedi[çc][ãa]o)/i.test(txt);

  if (isConditional && !['HOMOLOGACAO_CALCULO', 'EXPEDICAO_PAGAMENTO'].includes(intent)) {
    return false;
  }

  // 2. Intent explícito confirmado da IA
  if (intent === 'HOMOLOGACAO_CALCULO' || intent === 'EXPEDICAO_PAGAMENTO') {
    if (isConditional && !/(homologo(-o)?\s+(o\s+c[áa]lculo|a\s+conta|o\s+laudo|o\s+acordo)|expe[çc]a-se\s+(o\s+)?(rpv|precat[óo]rio|of[íi]cio\s+requisit[óo]rio)|determino\s+a\s+expedi[çc][ãa]o)/i.test(resumo)) {
      return false;
    }
    return true;
  }

  // 3. Padrões afirmativos diretos e inequívocos
  const affirmativePatterns = [
    /homologo(-o)?\s+(o\s+c[áa]lculo|os\s+c[áa]lculos|a\s+conta|o\s+laudo|o\s+acordo|a\s+liquida[çc][ãa]o)/i,
    /fica\s+homologado\s+(o\s+c[áa]lculo|o\s+valor|a\s+conta)/i,
    /declaro\s+homologado\s+(o\s+c[áa]lculo|o\s+acordo)/i,
    /homologo-o\s+para\s+que\s+produza/i,
    /acolho\s+os\s+c[áa]lculos\s+(apresentados\s+)?e\s+homologo/i,
    /determino\s+a\s+expedi[çc][ãa]o\s+de\s+(precat[óo]rio|rpv|of[íi]cio\s+requisit[óo]rio)/i,
    /expe[çc]a-se\s+(o\s+competente\s+)?(of[íi]cio\s+requisit[óo]rio|precat[óo]rio|rpv)/i,
    /requisite-se\s+o\s+pagamento/i,
    /ordeno\s+a\s+expedi[çc][ãa]o\s+de\s+(rpv|precat[óo]rio|of[íi]cio)/i,
    /(precat[óo]rio|rpv|of[íi]cio\s+requisit[óo]rio)\s+expedid[oa]/i,
    /concord[âa]ncia\s+com\s+o\s+c[áa]lculo\s+homologad[oa]/i
  ];

  return affirmativePatterns.some((pattern) => pattern.test(txt));
};




// Helper: Clean prefix tags from decision text

const cleanDecisionText = (text) => {

  if (!text) return '';

  return text

    .replace(/^\[AÇÃO NECESSÁRIA\]\s*:?/i, '')

    .replace(/^\[ACAO NECESSARIA\]\s*:?/i, '')

    .replace(/^\[MERA MOVIMENTAÇÃO\]\s*:?/i, '')

    .replace(/^\[MERA MOVIMENTACAO\]\s*:?/i, '')

    .replace(/^AÇÃO NECESSÁRIA:\s*/i, '')

    .replace(/^ACAO NECESSARIA:\s*/i, '')

    .replace(/^MERA MOVIMENTAÇÃO:\s*/i, '')

    .replace(/^MERA MOVIMENTACAO:\s*/i, '')

    .trim();

};



const fetchIntimacoes = () => {

  const params = {

    tab: activeTab.value,

  };

  if (filtroAdvogado.value && filtroAdvogado.value !== 'all') {
    params.advogado = filtroAdvogado.value;
  }
  if (filtroDocumentos.value && filtroDocumentos.value !== 'all') {
    params.documentos = filtroDocumentos.value;
  }

  if (activeTab.value !== 'favoritas' && activeTab.value !== 'nao_lidas') {
    if (filterLidas.value && !filterNaoLidas.value) params.is_read = 'true';
    if (filterNaoLidas.value && !filterLidas.value) params.is_read = 'false';
  }

  if (filterFavoritas.value) params.is_favorite = 'true';
  if (filterComPrazo.value) params.with_deadline = 'true';
  if (dateStart.value) params.date_start = dateStart.value;
  if (dateEnd.value) params.date_end = dateEnd.value;
  if (selectedDate.value) params.date_availability = selectedDate.value;
  if (tribunal.value !== 'all') params.tribunal = tribunal.value;

  if (searchQuery.value) params.q = searchQuery.value;

  store.dispatch('intimacoes/get', params);
  store.dispatch('intimacoes/getSummary');
};



let searchTimeout = null;

const onSearchInput = () => {

  clearTimeout(searchTimeout);

  searchTimeout = setTimeout(() => {

    fetchIntimacoes();
  fetchRegisteredLawyers();

  }, 300);

};



const clearFilters = () => {

  activeTab.value = 'nao_lidas';
  filtroAdvogado.value = 'all';
  filtroDocumentos.value = 'all';

  filterLidas.value = false;

  filterNaoLidas.value = false;

  filterFavoritas.value = false;

  filterComPrazo.value = false;

  selectedDate.value = todayStr;

  dateStart.value = '';

  dateEnd.value = '';

  tribunal.value = 'all';

  searchQuery.value = '';

  fetchIntimacoes();
  fetchRegisteredLawyers();

};



const toggleExpand = (id) => {

  const index = expandedIds.value.indexOf(id);

  if (index !== -1) {

    expandedIds.value.splice(index, 1);

  } else {

    expandedIds.value.push(id);

    const item = intimacoes.value.find(i => i.id === id);

    if (item && !item.is_read) {

      store.dispatch('intimacoes/toggleRead', id);

    }

  }

};



const toggleSelect = (id) => {

  const index = selectedIds.value.indexOf(id);

  if (index !== -1) {

    selectedIds.value.splice(index, 1);

  } else {

    selectedIds.value.push(id);

  }

};



const toggleSelectAll = () => {

  if (selectedIds.value.length === intimacoes.value.length) {

    selectedIds.value = [];

  } else {

    selectedIds.value = intimacoes.value.map(i => i.id);

  }

};



const handleToggleFavorite = (id) => {

  store.dispatch('intimacoes/toggleFavorite', id);

};



const handleToggleRead = (id) => {

  store.dispatch('intimacoes/toggleRead', id);

};



const handleBulkAction = async (updates) => {

  if (selectedIds.value.length === 0) return;

  await store.dispatch('intimacoes/bulkUpdate', {

    ids: selectedIds.value,

    ...updates,

  });

  selectedIds.value = [];

  fetchIntimacoes();
  fetchRegisteredLawyers();

};



// Link Modal Functions

const openLinkModal = (item) => {

  selectedItemForLink.value = item;

  linkConversationId.value = item.conversation_id || '';

  contactSearchQuery.value = item.dados?.parte_autora || item.process_number || '';

  selectedTargetForLink.value = null;

  applyPrazoTag.value = true;

  sendPrivateNoteOnLink.value = true;

  sendClientMessage.value = false;

  clientMessageText.value = `Olá ${item.dados?.parte_autora || ''}! Identificamos uma nova movimentação no seu processo nº ${item.process_number || ''}. Resumo: ${item.dados?.resumo_decisao || ''}. Qualquer dúvida estamos à disposição.`;

  linkModalTab.value = 'search';

  linkAssignedUserId.value = null;



  // Calculate default due date

  let defaultDueDate = todayStr;

  if (item.dados?.data_limite_estimada) {

    const raw = item.dados.data_limite_estimada.toString();

    if (raw.includes('/')) {

      const p = raw.split('/');

      if (p.length === 3) defaultDueDate = `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;

    } else if (raw.includes('-')) {

      defaultDueDate = raw;

    }

  } else if (item.dados?.prazo_concedido && parseInt(item.dados.prazo_concedido, 10) > 0) {

    const d = new Date();

    d.setDate(d.getDate() + parseInt(item.dados.prazo_concedido, 10));

    defaultDueDate = d.toISOString().split('T')[0];

  }



  linkCreateTarefa.value = true;

  linkTarefaDueDate.value = defaultDueDate;

  linkTarefaDueTime.value = '08:00';

  linkTarefaPriority.value = (item.full_text && item.full_text.includes('[AÇÃO NECESSÁRIA]')) ? 'urgente' : 'alta';

  linkTarefaIsFatal.value = false;

  linkMoveKanban.value = true;

  linkKanbanStage.value = 'PRAZOS';

  showLinkModal.value = true;

  if (contactSearchQuery.value) {

    onSearchContacts();

  }

};



let contactSearchTimeout = null;

const onSearchContacts = () => {

  clearTimeout(contactSearchTimeout);

  contactSearchTimeout = setTimeout(async () => {

    if (!contactSearchQuery.value || contactSearchQuery.value.length < 2) {

      contactResults.value = [];

      return;

    }

    isSearchingContacts.value = true;

    try {

      const res = await IntimacoesAPI.searchTargets(contactSearchQuery.value);

      contactResults.value = res.data || [];

    } catch (e) {

      console.error(e);

    } finally {

      isSearchingContacts.value = false;

    }

  }, 250);

};



const confirmLinkConversation = async () => {

  if (!selectedItemForLink.value) return;

  

  isLinking.value = true;

  let convId = linkConversationId.value;

  let contactId = null;



  if (linkModalTab.value === 'search' && selectedTargetForLink.value) {

    convId = selectedTargetForLink.value.conversation_id;

    contactId = selectedTargetForLink.value.contact_id;

  }



  try {

    await IntimacoesAPI.linkConversation(selectedItemForLink.value.id, {

      conversation_id: convId,

      contact_id: contactId,

      move_kanban_stage: linkMoveKanban.value,

      kanban_stage: linkKanbanStage.value,

      kanban_attribute_key: 'servidor',

      send_private_message: sendPrivateNoteOnLink.value,

      send_client_message: sendClientMessage.value,

      client_message_content: clientMessageText.value,

      assigned_user_id: linkAssignedUserId.value,

      create_tarefa: linkCreateTarefa.value,

      tarefa_due_date: linkTarefaDueDate.value,

      tarefa_due_time: linkTarefaDueTime.value || '08:00',

      tarefa_priority: linkTarefaPriority.value,

      is_fatal_deadline: linkTarefaIsFatal.value,

    });

  } catch (e) {

    console.error('Error linking conversation:', e);

  } finally {

    isLinking.value = false;

  }



  showLinkModal.value = false;

  fetchIntimacoes();
  fetchRegisteredLawyers();

};



const copyToClipboard = (text) => {

  if (!text) return;

  navigator.clipboard.writeText(text);

};



const formatDate = (dateStr) => {

  if (!dateStr) return '-';

  try {

    const parts = dateStr.split('-');

    if (parts.length === 3) {

      return `${parts[2]}/${parts[1]}/${parts[0]}`;

    }

    return dateStr;

  } catch (e) {

    return dateStr;

  }

};



onMounted(() => {

  fetchIntimacoes();
  fetchRegisteredLawyers();

  store.dispatch('agents/get');

});

</script>



<style scoped>

.unread-intimacao-card {
  background-color: #FAFADC !important;
}

html.dark .unread-intimacao-card,
body.dark .unread-intimacao-card,
.dark .unread-intimacao-card,
[data-theme='dark'] .unread-intimacao-card {
  background-color: #403B2B !important;
  border-color: #5c5338 !important;
}

</style>



<style scoped>

.drawer-fade-enter-active,

.drawer-fade-leave-active {

  transition: opacity 0.25s ease;

}

.drawer-fade-enter-from,

.drawer-fade-leave-to {

  opacity: 0;

}



.drawer-slide-enter-active,

.drawer-slide-leave-active {

  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);

}

.drawer-slide-enter-from,

.drawer-slide-leave-to {

  transform: translateX(100%);

}

</style>

